import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Cms } from '@impact/data';

import { UtilitiesService } from '../core/utilities.service';
import { DealershipDepartments } from '../models/dealerships';

@Component({
    selector: 'app-opening-hours',
    template: `
        <ng-container *ngIf="openingHoursData">
            <div class="opening-hours-list" role="table" *ngIf="openingHoursData.length">
                <div class="opening-hours-list-item"
                    *ngFor="let hours of openingHoursData; let i = index"
                    [ngClass]="{ 'is-today': i === 0 }"
                    role="row">
                    <div role="cell">{{ utilitesService.getWeekDaysTranslations(hours?.dayOfTheWeek) }}</div>
                    <div role="cell">{{ hours?.date | date: 'dd/MM' }}</div>
                    <div role="cell" [ngSwitch]="hours?.isOpen">
                        <ng-container *ngSwitchCase="true">
                            <div *ngFor="let item of hours?.hoursOfBusiness">
                                <time [attr.datetime]="item?.opensAt | date: 'HH.mm'">{{ item?.opensAt | date: 'HH.mm' }}</time> -
                                <time [attr.datetime]="item?.closesAt | date: 'HH.mm'">{{ item?.closesAt | date: 'HH.mm' }}</time>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="false">{{ 'dealerships.dealership_closed_text' | translate }}</ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpeningHoursComponent implements OnChanges {
    @Input() data: Cms.DepartmentDto;
    @Input() department: DealershipDepartments;

    weekDayIndex: number;
    openingHoursDepartmentName: string;
    openingHoursData: Cms.NextSevenDaysDto[];

    constructor(private cdr: ChangeDetectorRef, public utilitesService: UtilitiesService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data.currentValue) {
            const date = new Date();
            this.weekDayIndex = date.getDay();

            const data = changes.data.currentValue;
            this.openingHoursData = data.nextSevenDays;

            this.cdr.markForCheck();
        }
    }
}
